import { useQuery } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';
import type {
  V3ApiSuccessData,
  V3ApiError,
} from 'javascripts/services/v3ApiClient';

import { type TrustyIndustry } from '../types';

export type GetTrustyIndustriesResponse = V3ApiSuccessData<{
  industries: TrustyIndustry[];
}>;

export const useGetTrustyIndustries = () => {
  return useQuery<GetTrustyIndustriesResponse, V3ApiError>({
    queryFn: async () => {
      const response = await request({
        url: `/trusty/industries`,
      });
      return response.data;
    },
    queryKey: ['trusty/industries'],
  });
};
